import { render, staticRenderFns } from "./ProductListGridFooter.vue?vue&type=template&id=7d60033c"
import script from "./ProductListGridFooter.vue?vue&type=script&lang=js"
export * from "./ProductListGridFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports